import React, {ReactNode} from 'react';
import clsx from "clsx";

import {cFormGroupProps} from "../../utils";

import FormGroupErrorText from "./FormGroupErrorText";
import FormGroupHelpText from "./FormGroupHelpText";

interface FormGroupProps extends cFormGroupProps {
  name: string;
  children: ReactNode;
  hasErrors?: string | false | undefined;
  errorText?: string;
}

function FormGroup(
  {
    extraClassName,
    formGroupStyle,
    name,
    labelText,
    labelIsHidden,
    inputGroupText,
    inputGroupPlacement,
    formGroupExtraContent,
    helpText,
    hideHelpIcon,
    hasErrors,
    errorText,
    hideError,
    children,
  }: FormGroupProps) {
  return (
    <div
      className={clsx("c-form-group", extraClassName && extraClassName, hasErrors && "is-invalid" )}
      data-form-group-style={formGroupStyle}
      data-input-group={inputGroupText && "is-input-group"}
      data-input-group-placement={inputGroupText && inputGroupPlacement}
    >

      <div className="c-form-group-wrapper">

        <div className="c-form-group-content">

          {formGroupStyle === "block-line" && (
            <div className="c-form-group-border"/>
          )}

          <label
            htmlFor={`id_${name}`}
            className={clsx(labelIsHidden && "c-visually-hidden")}
          >
            {labelText}
          </label>

          <div className="c-form-group-input-group">

            {children}

            {inputGroupText && (
              <div className="c-form-group-input-group-text">
                {inputGroupText}
              </div>
            )}

          </div>

        </div>

        {formGroupExtraContent && (
          <div className="c-form-group-content-extra">
            {formGroupExtraContent}
          </div>
        )}

      </div>

      {helpText && (
        <FormGroupHelpText
          helpText={helpText}
          hideHelpTextIcon={hideHelpIcon}
        />
      )}

      {!hideError && hasErrors? (
        <FormGroupErrorText text={errorText}/>
      ) : null}

    </div>
  );
}

export default FormGroup;